import axiosRequest from "@/utils/axios-utils";

export const getPageContent = async (handshake, page_id) => {
  const config = {
    method: "get",
    url: `/cms/page/${page_id}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };
  console.log(
    "😂😂😂😂😂😂 getPageContent config ==================>>",
    config
  );
  try {
    const req = await axiosRequest(config);
    console.log("✅✅✅✅✅✅ getPageContent ==================>>", req);
    return req;
  } catch (error) {
    console.log("❌❌❌❌❌❌ getPageContent ==================>>", error);
    return error;
  }
};
export const getcmsPageByUrl = async (handshake, url) => {
  const config = {
    method: "get",
    url: `/cms/pageSearchUrlKey/${url}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };
  try {
    const req = await axiosRequest(config);
    console.log("////////////", config.url);
    // console.log("getPageContent ==================>>", req);
    return req?.data
  } catch (error) {
    // console.log("getPageContent ==================>>", error);
    return error;
  }
};

// Browser-only: goes through the MW proxy (/api/mw), which adds the handshake of the page's
// locale, so the banner comes from the matching Magento store view.
export const getCountdownBanner = async () => {
  try {
    return await axiosRequest({ method: "get", url: "/cms/countdown-banner" });
  } catch (error) {
    return error;
  }
};
